import {GraphQLService} from "./graphql.service";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Product} from "../models/product.model";
import {Observable} from "rxjs";
import {Pagination} from "../models/pagination.model";
import {TranslateService} from "@ngx-translate/core";
import {CurrencyPrice} from "../models/currency_price.model";
import {Language} from "../models/language.model";
import {MatSnackBar} from "@angular/material/snack-bar";
import {BookLaunchOffer} from "../models/book_launch_offer.model";

@Injectable()
export class BookLaunchOfferService extends GraphQLService<BookLaunchOffer> {
  constructor(
    http: HttpClient,
    snackBar: MatSnackBar,
    private translate: TranslateService
  ) {
    super(http, snackBar);
    /* DO NOT DELETE */
    new Product()
    new CurrencyPrice()
    /* DO NOT DELETE END */
  }

  byCode(token: string) {
    return this.find(`{ bookLaunchOffer(token: "${token}") { countdown
    product {
      id title internalId priceNetto productBook {
        title language subtitle blurb isbn hardcover numpages publishedAt publisher { name url }
      }
      currencyPrices { currency exchangeRate netPrice }
      category { id }
    }
    tiers {
      code validUntil bookPrice quantity
      currencyBookPrices { currency exchangeRate netPrice }
      currencyAuthorSavings { currency exchangeRate netPrice }
      currencyDiscountedAuthorPrices { currency exchangeRate netPrice }
    }
    }
    }`)
  }

}
